<template>
  <tr>
    <td>
      <router-link
        :to="{
          path: `/${urlVisor}/${item.numeroVenta}`
        }"
      >
        {{ item.numeroVenta }}
      </router-link>
    </td>
    <td>{{ item.tipoVenta }}</td>
    <td>{{ item.numeroDocumento }}</td>
    <td>{{ vendedor }}</td>
    <td>
      {{ responsable }}
      <b-tooltip
        v-if="usaMovil"
        class="is-pulled-right"
        type="is-info"
        label="Conectado desde dispositivo móvil"
        :delay="200"
      >
        <b-icon
          class="is-pulled-right"
          icon="mobile-alt"
          size="is-small"
          type="is-info"
        />
      </b-tooltip>
    </td>
    <td>{{ zona }}</td>
    <td>
      {{ item.tipoPedido }}&nbsp;
      <strong class="tag is-pulled-right is-info is-rounded">
        {{ item.numeroItems }}
      </strong>
    </td>
    <td>
      {{ item.tipoEntrega.nombre }}
      <b-tooltip
        v-if="iconoTipoEntrega.tieneIcono"
        class="is-pulled-right ml-1"
        type="is-info"
        :label="`Tipo Entrega: ${item.tipoEntrega.nombre}`"
        :delay="200"
      >
        <b-icon
          :icon="iconoTipoEntrega.icono"
          size="is-small"
          :pack="iconoTipoEntrega.pack"
          :type="iconoTipoEntrega.color"
        />
      </b-tooltip>
    </td>
    <td>
      {{ item.estado }}
    </td>
    <td>{{ fecha }}</td>
    <td>
      <strong
        v-if="item.fechaFacturacion && !item.estaProgramado"
        class="tag is-info"
        :style="estiloBadge"
      >
        {{ tiempo }}
      </strong>
      <strong
        v-if="item.fechaEntrega && item.estaProgramado"
        class="tag is-info"
        :style="estiloBadgeRestante"
      >
        {{ tiempoRestante }}
      </strong>
      <b-icon
        v-if="item.fechaEntrega && item.estaProgramado"
        icon="bell"
        type="is-danger"
      ></b-icon>
      <b-tooltip
        v-if="!hayAcciones && item.esCopia"
        class="is-pulled-right"
        type="is-info"
        label="Es copia"
        :delay="200"
      >
        <b-icon icon="copy" size="is-small" type="is-danger" />
      </b-tooltip>
    </td>
    <td v-if="hayAcciones" class="item-acciones">
      <b-tooltip
        v-if="puedeAsignarPedido"
        class="accion-pedido"
        type="is-info"
        label="Asignar picking"
        :delay="200"
      >
        <b-button
          type="is-info"
          size="is-small"
          title="Asignar picking"
          @click="asignarPedido(item.id)"
        >
          <b-icon icon="user-check" />
        </b-button>
      </b-tooltip>
      &nbsp;
      <b-tooltip
        v-if="puedeReimprimir"
        class="accion-pedido"
        type="is-info"
        label="Re-imprimir picking"
        :delay="200"
      >
        <b-button
          type="is-info"
          size="is-small"
          title="Re-imprimir picking"
          @click="imprimirPedido(item.id)"
        >
          <b-icon icon="print" />
        </b-button>
      </b-tooltip>
      &nbsp;
      <b-tooltip
        v-if="puedeDespachoPedido"
        class="accion-pedido"
        type="is-primary"
        label="Despachar pedido"
        :delay="200"
      >
        <router-link
          class="button is-small is-info"
          type="button"
          tag="button"
          title="Despachar pedido"
          :to="{ path: `/cierre/${item.id}` }"
        >
          <b-icon icon="box-open" />
        </router-link>
      </b-tooltip>
      <b-tooltip
        v-if="puedePausar"
        class="accion-pedido"
        type="is-info"
        :label="etiquetaBotonPausa"
        :delay="200"
      >
        <b-button
          type="is-info"
          size="is-small"
          :title="etiquetaBotonPausa"
          @click="pausarEjecucionPedido(item.id)"
        >
          <b-icon :icon="iconoEjecucion"></b-icon>
        </b-button>
      </b-tooltip>
      <b-tooltip
        v-if="item.esCopia"
        class="is-pulled-right"
        type="is-info"
        label="Es copia"
        :delay="200"
      >
        <b-icon icon="copy" size="is-small" type="is-danger" />
      </b-tooltip>
      <b-modal
        :active.sync="estaModalAbierto"
        has-modal-card
        trap-focus
        aria-role="dialog"
        aria-modal
        @close="cerrarModalHandle"
      >
        <seleccion-asignacion
          :bodega="bodega"
          :pedido="item"
          @cancelar="cerrarModalHandle"
        />
      </b-modal>
    </td>
  </tr>
</template>

<script>
import {
  differenceInHours,
  differenceInMinutes,
  format,
  parseISO
} from 'date-fns'
import { mapGetters } from 'vuex'

import SeleccionAsignacion from '@/components/monitorUsuario/SeleccionAsignacion.vue'
import { pedidoService } from '@/services'

export default {
  name: 'PedidosItem',
  components: {
    SeleccionAsignacion
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    modo: {
      type: String,
      // default: 'picking'
      default: 'despacho'
    }
  },
  data() {
    return {
      ahora: Date.now(),
      intervalo: '',
      espera: {
        maximo: 40,
        minimo: 10
      },
      estilo: {
        fondo: 'white',
        texto: 'black',
        sombra: null,
        hue: 0
      },
      estaModalAbierto: false
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    fecha() {
      return format(
        parseISO(
          this.item.fechaFacturacion
            ? this.item.fechaFacturacion
            : this.item.fecha
        ),
        'dd/MM/yy HH:mm'
      )
    },
    iconoTipoEntrega() {
      if (this.item.tipoEntrega.icono === null) return { tieneIcono: false }
      let color = ''
      switch (this.item.tipoEntrega.color) {
        case 'rojo':
          color = 'is-danger'
          break
        case 'amarillo':
          color = 'is-warning'
          break
        case 'azul':
          color = 'is-info'
          break
        case 'verde':
          color = 'is-success'
          break
        default:
          color = 'is-info'
      }
      return {
        tieneIcono: true,
        color,
        pack: 'fab',
        icono: this.item.tipoEntrega.icono
      }
    },
    tiempo() {
      if (!this.item.fechaFacturacion) return ''
      const horas = differenceInHours(
        this.ahora,
        parseISO(this.item.fechaFacturacion)
      )
        .toString()
        .padStart(2, '0')
      const minutos = (
        differenceInMinutes(this.ahora, parseISO(this.item.fechaFacturacion)) -
        horas * 60
      )
        .toString()
        .padStart(2, '0')
      return `hace ${horas}:${minutos}`
    },
    tiempoRestante() {
      if (!this.item.estaProgramado) return ''
      if (!this.item.fechaEntrega) return ''
      const horas = differenceInHours(
        parseISO(this.item.fechaEntrega),
        this.ahora
      )
        .toString()
        .padStart(2, '0')
      const minutos = (
        differenceInMinutes(parseISO(this.item.fechaEntrega), this.ahora) -
        horas * 60
      )
        .toString()
        .padStart(2, '0')
      if (horas < 0 || minutos < 0) return 'queda 00:00'
      return `queda ${horas}:${minutos}`
    },
    minutos() {
      return differenceInMinutes(
        this.ahora,
        parseISO(this.item.fechaFacturacion)
      )
    },
    minutosRestantes() {
      return differenceInMinutes(parseISO(this.item.fechaEntrega), this.ahora)
    },
    vendedor() {
      return this.item.vendedor ? this.item.vendedor.nombre : ''
    },
    responsable() {
      return this.item.responsable ? this.item.responsable.nombre : ''
    },
    zona() {
      return this.item.zona ? this.item.zona.nombre : ''
    },
    hayAcciones() {
      return (
        (this.bodega.puedeReimprimir || this.bodega.puedePickearVendedor) &&
        // Si usuario tiene rol Monitor, no se muestran acciones
        !this.bodega.roles.some((rol) => rol.id === 6)
      )
    },
    puedeReimprimir() {
      return (
        this.bodega.puedeReimprimir &&
        this.item.estado.toLowerCase() === 'enejecucion' &&
        !this.esPedidoMultiplePadre
      )
    },
    puedeAsignarPedido() {
      return (
        this.bodega.puedePickearVendedor &&
        this.item.estado.toLowerCase() === 'clasificado' &&
        !this.esPedidoMultiplePadre
      )
    },
    puedeDespachoPedido() {
      return (
        this.item.estado.toLowerCase() === 'completado' &&
        (this.esPedidoMultiplePadre || !this.item.esSubpedido)
      )
    },
    esPedidoMultiplePadre() {
      return this.esPedidoMultiple && !this.item.esSubpedido
    },
    esPedidoMultiple() {
      const tipoPedido = this.item.tipoPedido?.toLowerCase() ?? ''
      const opciones = ['múltiple', 'multiple', '3']
      return opciones.some((o) => o === tipoPedido)
    },
    estiloBadge() {
      let estilo = {
        'background-color': this.estilo.fondo,
        color: this.estilo.texto
      }
      if (this.estilo.sombra) {
        estilo = Object.assign(estilo, { 'text-shadow': this.estilo.sombra })
      }
      return estilo
    },
    estiloBadgeRestante() {
      let estilo = {
        'background-color': this.estilo.fondo,
        color: this.estilo.texto
      }
      if (this.estilo.sombra) {
        estilo = Object.assign(estilo, { 'text-shadow': this.estilo.sombra })
      }
      return estilo
    },
    estiloLinea() {
      return {
        'background-color': `${this.colorLinea} !important`
      }
    },
    usaMovil() {
      if (!this.item.responsable) return false
      return this.item.responsable.usaDispositivoMovil
    },
    puedePausar() {
      if (this.esPedidoMultiplePadre) return false
      const estados = ['asignado', 'enejecucion']
      if (!estados.includes(this.item.estado.toLowerCase())) return false
      const tipoEntrega = this.bodega.tiposEntrega.find(
        (te) => te.id === this.item.tipoEntrega.id
      )
      return tipoEntrega.puedePausar || this.item.puedePausarse
    },
    iconoEjecucion() {
      return this.item.estaPausado ||
        this.item.estado.toLowerCase() === 'asignado'
        ? 'play'
        : 'pause'
    },
    etiquetaBotonPausa() {
      return this.item.estaPausado ? 'Reanudar pedido' : 'Pausar pedido'
    },
    urlVisor() {
      return this.modo === 'despacho' ? 'entrega' : 'pedido'
    }
  },
  watch: {
    item() {
      if (this.item.fechaFacturacion) this.calcularTiempo()
    }
  },
  created() {
    this.espera = {
      minimo: parseInt(process.env.VUE_APP_MIN_ESPERA ?? 0),
      maximo: parseInt(process.env.VUE_APP_MAX_ESPERA ?? 15)
    }
  },
  mounted() {
    const self = this
    this.calcularTiempo()
    const tiempo = this.item.estaProgramado ? 60000 : 30000
    this.intervalo = setInterval(() => self.calcularTiempo(), tiempo)
  },
  beforeDestroy() {
    clearInterval(this.intervalo)
  },
  methods: {
    imprimirPedido(id) {
      pedidoService
        .imprimirPedido(id)
        .then(() => {
          this.notificarAccionCompletada(
            'Se envió impresión de picking list correctamente'
          )
        })
        .catch((error) => this.procesarError(error))
    },
    pausarEjecucionPedido(id) {
      const accion = this.item.estaPausado ? 'reanudó' : 'pausó'
      pedidoService
        .pausarEjecucionPedido(id)
        .then((rs) => {
          this.$store.commit('monitor/PEDIDO_UPDATE', rs.data)
          this.notificarAccionCompletada(
            `Se ${accion} la ejecución del pedido correctamente`
          )
        })
        .catch((error) => this.procesarError(error))
    },
    calcularColorFondo() {
      const opacidad = 1
      const hue = this.estilo.hue
      return `hsla(${hue}, 100%, 50%, ${opacidad})`
    },
    calcularColorTexto() {
      const hue = this.estilo.hue
      if (hue >= 45) return '#000'
      return '#fff'
    },
    calcularColorSombra() {
      const hue = this.estilo.hue
      let color = '#000'
      if (hue >= 45) color = '#fff'
      return `2px 2px 4px ${color}`
    },
    calcularHue() {
      const maxHue = 120
      const minHue = 0
      let porcentaje = 0
      if (this.item.estaProgramado) {
        if (this.minutosRestantes < 0) return minHue
        if (this.minutosRestantes > this.item.minutosPrevioAsignacion)
          return maxHue
        porcentaje = (
          this.minutosRestantes / this.item.minutosPrevioAsignacion
        ).toFixed(2)
      } else {
        if (this.minutos > this.espera.maximo) return minHue
        porcentaje = (1 - this.minutos / this.espera.maximo).toFixed(2)
      }
      const hue = porcentaje * (maxHue - minHue) + minHue
      return hue
    },
    calcularTiempo() {
      this.ahora = new Date()
      this.estilo.hue = this.calcularHue()
      this.estilo = {
        fondo: this.calcularColorFondo(),
        texto: this.calcularColorTexto(),
        sombra: this.calcularColorSombra()
      }
    },
    asignarPedido() {
      this.estaModalAbierto = true
    },
    cerrarModalHandle() {
      this.estaModalAbierto = false
    }
  }
}
</script>

<style lang="scss" scoped>
.item-acciones {
  padding-left: 5px;
  padding-right: 5px;
  // width: 96px;
}
.accion-pedido {
  margin-right: 4px;
  float: left;
}
</style>
